import Box from '@material-ui/core/Box'
import Card from '@material-ui/core/Card'
import CardActions from '@material-ui/core/CardActions'
import CardContent from '@material-ui/core/CardContent'
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'
import * as React from 'react'

import { CardActionArea } from '../base/Card'
import Typography from '../base/Typography'
import CardPopover, { CardPopoverProps } from '../molecules/CardPopover'
import Tags, { CustomVariant } from '../tags/Tags'

export interface ResignedCleaner {
  firstName: string
  lastName: string
  contactNumber: string
  workerType: string
  nationality: string
  lastWorkingDay: string
}

export type ResignationCardProps = {
  resignedCleaner: ResignedCleaner
  tagLabel: string
  labelVariant: CustomVariant
  onClick(): void
  data?: CardPopoverProps['data']
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    card: {
      width: theme.spacing(30),
      maxWidth: '100%',
      borderRadius: 4
    },
    cardContent: {
      paddingBottom: 0
    },
    cardContentHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      marginBottom: theme.spacing(2)
    },
    cardContentBody: {
      display: 'grid',
      gridTemplateColumns: 'min-content 1fr',
      gridColumnGap: theme.spacing(3),
      marginBottom: theme.spacing(3)
    },
    cardContentFooter: {
      display: 'grid',
      gridRowGap: theme.spacing(0.5)
    },
    cardActionRoot: {
      padding: 0,
      justifyContent: 'flex-end'
    },
    textColor: {
      color: theme.palette.grey[800]
    }
  })
)

const ResignationCard: React.FC<ResignationCardProps> = (props) => {
  const { resignedCleaner, data, tagLabel, labelVariant, onClick } = props
  const classes = useStyles()
  const menuOpenPopover = (event: { stopPropagation: () => void }): void => {
    event.stopPropagation()
  }
  return (
    <CardActionArea onClick={onClick} className={classes.card}>
      <Card elevation={1}>
        <CardContent className={classes.cardContent}>
          <Box className={classes.cardContentHeader}>
            <Typography
              variant="subtitle2"
              children={`${resignedCleaner.firstName} ${resignedCleaner.lastName}`}
            />
            <Tags customVariant={labelVariant} label={tagLabel} sizes="xs" />
          </Box>
          <Box className={classes.cardContentBody}>
            <Typography
              className={classes.textColor}
              variant="caption"
              children="Phone:"
            />
            <Typography
              variant="caption"
              children={resignedCleaner.contactNumber}
            />
            <Typography
              className={classes.textColor}
              variant="caption"
              children="Type:"
            />
            <Typography
              variant="caption"
              children={resignedCleaner.workerType}
            />
            <Typography
              className={classes.textColor}
              variant="caption"
              children="Nationality:"
            />
            <Typography
              variant="caption"
              children={resignedCleaner.nationality}
            />
          </Box>
          <Box className={classes.cardContentFooter}>
            <Typography
              className={classes.textColor}
              variant="caption"
              children="Last Working Day"
            />
            <Typography
              variant="caption"
              children={resignedCleaner.lastWorkingDay}
            />
          </Box>
        </CardContent>
        {data && (
          <CardActions
            onClick={menuOpenPopover}
            classes={{ root: classes.cardActionRoot }}
          >
            <CardPopover data={data} />
          </CardActions>
        )}
      </Card>
    </CardActionArea>
  )
}

export default ResignationCard
